import React from "react";
import PropTypes from "prop-types";

import { Button } from "reactstrap";

import "./RefreshButton.scss";

const DEFAULT_COLOR = "primary";

const ResetButton = (props) => {
  const { color, onClick } = props;

  return (
    <div className="blu-refresh-btn">
      <Button color={color} onClick={onClick}>
        <i className="fas fa-times fa-lg" />
        &nbsp;&nbsp; Reset
      </Button>
    </div>
  );
};

ResetButton.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
};

ResetButton.defaultProps = {
  color: DEFAULT_COLOR,
  onClick: () => {},
};

export default ResetButton;
